/**
 * Accedo OVP
 * API version: 1.2.0
 *
 * NOTE: This class was automatically generated by Swagger Code Generator. Do not edit it manually.
 */
'use strict';

var ApiClient = require('../ApiClient');




  /**
   * The Content model module.
   * @module model/Content
   * @version 1.4.0
   */

  /**
   * Constructs a new <code>Content</code>.
   * a video
   * @alias module:model/Content
   * @class
   */
  var exports = function() {
    var _this = this;













  };

  /**
   * Constructs a <code>Content</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Content} obj Optional instance to populate.
   * @return {module:model/Content} The populated <code>Content</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('format')) {
        obj['format'] = ApiClient.convertToType(data['format'], 'String');
      }
      if (data.hasOwnProperty('drm')) {
        obj['drm'] = ApiClient.convertToType(data['drm'], 'String');
      }
      if (data.hasOwnProperty('url')) {
        obj['url'] = ApiClient.convertToType(data['url'], 'String');
      }
      if (data.hasOwnProperty('width')) {
        obj['width'] = ApiClient.convertToType(data['width'], 'Number');
      }
      if (data.hasOwnProperty('height')) {
        obj['height'] = ApiClient.convertToType(data['height'], 'Number');
      }
      if (data.hasOwnProperty('duration')) {
        obj['duration'] = ApiClient.convertToType(data['duration'], 'Number');
      }
      if (data.hasOwnProperty('language')) {
        obj['language'] = ApiClient.convertToType(data['language'], 'String');
      }
      if (data.hasOwnProperty('mediaId')) {
        obj['mediaId'] = ApiClient.convertToType(data['mediaId'], 'String');
      }
      if (data.hasOwnProperty('isTrailer')) {
        obj['isTrailer'] = ApiClient.convertToType(data['isTrailer'], 'Boolean');
      }
      if (data.hasOwnProperty('isLive')) {
        obj['isLive'] = ApiClient.convertToType(data['isLive'], 'Boolean');
      }
    }
    return obj;
  };

  /**
   * identifier for the video
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * title of the video
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * format of the video
   * @member {String} format
   */
  exports.prototype['format'] = undefined;
  /**
   * DRM of the video. playready, verimatrix, widevine.
   * @member {String} drm
   */
  exports.prototype['drm'] = undefined;
  /**
   * URL of video
   * @member {String} url
   */
  exports.prototype['url'] = undefined;
  /**
   * width of video in pixels
   * @member {Number} width
   */
  exports.prototype['width'] = undefined;
  /**
   * height of video in pixels
   * @member {Number} height
   */
  exports.prototype['height'] = undefined;
  /**
   * the duration of the video in milliseconds
   * @member {Number} duration
   */
  exports.prototype['duration'] = undefined;
  /**
   * language of the video in ISO 639 code. Empty or null for multiple languages
   * @member {String} language
   */
  exports.prototype['language'] = undefined;
  /**
   * the id of the associated media
   * @member {String} mediaId
   */
  exports.prototype['mediaId'] = undefined;
  /**
   * Indicates this video is a trailer
   * @member {Boolean} isTrailer
   */
  exports.prototype['isTrailer'] = undefined;
  /**
   * Indicates this video is a linear stream
   * @member {Boolean} isLive
   */
  exports.prototype['isLive'] = undefined;







module.exports = exports;